module.exports = __webpack_public_path__ + "static/media/oberflex-ormedamerique-1200x2490.b0259e3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-ormedamerique-1200x2490.jpg
// module id = 1046
// module chunks = 37